export const SET_VERSION = 'Version/SET_VERSION';

export const setVersion = (id) => ({
    type: SET_VERSION,
    id,
});
